import { isNullOrWhiteSpace } from 'owa-string-utils';
import { getParsedQueryStringFromUrl } from './getParsedQueryStringFromUrl';

export function extractFileUrlFromOfficeSharePointLink(url: string | null): string | null {
    const parsed = getParsedQueryStringFromUrl(url);
    if (!isNullOrWhiteSpace(parsed?.file)) {
        return decodeURI(parsed?.file);
    }

    return null;
}
